import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useGlobalContext } from '../common/hooks/useGlobalContext'
import { identifyUser as identifyLogrocketUser } from '../common/utils/logrocket'
import { identifyUser } from '../common/utils/metrics'

/**
 * Tells Jitsu, LogRocket and Sentry who the signed-in user is, so analytics events, recorded
 * sessions and errors can be tied to them. All three use the membership id.
 */
export function IdentifyUser() {
  const { user } = useGlobalContext()
  const id = user?.id
  const email = user?.email ?? null
  const phone = user?.phoneNumber ?? null
  const name = user === undefined ? undefined : `${user.firstName} ${user.lastName}`
  const organizationId = user?.organizationId
  const organizationName = user?.organizationName

  useEffect(() => {
    if (
      id === undefined ||
      name === undefined ||
      organizationId === undefined ||
      organizationName === undefined
    ) {
      return
    }

    identifyUser(id, { email, phone, name, organizationName })
    identifyLogrocketUser(id, {
      email,
      name,
      organizationId,
      organizationName,
    })
    Sentry.setUser({
      id,
      email: email ?? undefined,
      isInternal: email !== null && email.endsWith('@doss.com'),
    })

    return () => {
      Sentry.setUser(null)
    }
  }, [id, email, phone, name, organizationId, organizationName])

  return null
}
